import "./App.css";
import "./Fonts/style.css";
import { Switch, Route } from "react-router-dom";

import Home from "./Components/Home/Home";
import Pricing from "./Components/Pricing/Pricing";
import UnderConstruction from "./UnderConstruction";

import ArrayBundle from "./Components/Games/Arrays/ArrayBundle";
import Accessing from "./Components/Games/Arrays/Accessing/Accessing";
import Addressing from "./Components/Games/Arrays/Addressing/Addressing";
import Rotation from "./Components/Games/Arrays/Rotation/Rotation";
import Insertion from "./Components/Games/Arrays/Insertion/Insertion";
import Updation from "./Components/Games/Arrays/Updation/Updation";
import Deletion from "./Components/Games/Arrays/Deletion/Deletion";

import SearchingBundle from "./Components/Games/Searching/SearchingBundle";
import LinearSearch from "./Components/Games/Searching/LinearSearch/LinearSearch";
import BinarySearch from "./Components/Games/Searching/BinarySearch/BinarySearch";

function Main() {
	return (
		<div>
			<Home />
		</div>
	);
}

function App() {
	return (
		<Switch>
			<Route path="/" component={Main} exact />
			<Route path="/pricing" component={Pricing} exact />
			{/* --------------------------------------------- */}
			<Route path="/games/arrays" component={ArrayBundle} exact />
			<Route path="/games/arrays/accessing" component={Accessing} exact />
			<Route path="/games/arrays/addressing" component={Addressing} exact />
			<Route path="/games/arrays/rotation" component={Rotation} exact />
			<Route path="/games/arrays/insertion" component={Insertion} exact />
			<Route path="/games/arrays/updation" component={Updation} exact />
			<Route path="/games/arrays/deletion" component={Deletion} exact />
			{/* --------------------------------------------- */}
			<Route path="/games/searching" component={SearchingBundle} exact />
			<Route path="/games/searching/linear" component={LinearSearch} exact />
			<Route path="/games/searching/binary" component={BinarySearch} exact />
			{/* --------------------------------------------- */}
			<Route component={UnderConstruction} />
		</Switch>
	);
}

export default App;
